import './popup.css';
import React from 'react';
import { AiFillEdit, AiOutlineKey, AiOutlineLogout, AiOutlineUser, } from 'react-icons/ai';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { useLocation } from 'react-router-dom';
import { logout, getDashBoardLink } from '../../../utils/net';
import { initialLoginStageAtom, showLoginAtom, chatLangAtom, showApiDashboardAtom, subscriptionsInfoAtom, iframeAtom } from '../../../store';
import { FaCode } from "react-icons/fa";
import { useTips } from '../../../common/GlobalTips'
import { LuBookmarkPlus } from "react-icons/lu";
import * as Sentry from "@sentry/react";
import { AvatarImage } from '../../../common/AvatarImage';
import { useTranslation } from "react-i18next";
import Restricted from "../../../utils/restricted";
import { trackEvent } from '../../../utils/trackEvent'
import termsIcon from '../../../assets/settings_terms.svg'

// eslint-disable-next-line react/display-name
export const UserPopup = React.memo(React.forwardRef(({ className, userInfo, setShowUser }, ref) => {
    const locating = useLocation();
    const tip = useTips();
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const setInitialLoginStage = useSetRecoilState(initialLoginStageAtom);
    const setShowApiDashboard = useSetRecoilState(showApiDashboardAtom)
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const setIframe = useSetRecoilState(iframeAtom)


    const { t } = useTranslation();
    const handleLogout = async () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Logout Icon', 'User Panel']);
        localStorage.setItem('user_uuid', '');
        localStorage.setItem('privileged', '')
        localStorage.setItem('token', '');
        localStorage.setItem('group_uuid', '');
        trackEvent('Rodin - UserPopup - Login Out')
        await logout();
        window.location.href = locating.pathname;
    };

    const handleChangeAvatar = () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Change Avatar Icon', 'User Panel']);
        trackEvent('Rodin - UserPopup - Change Avatar: Open')
        setShowLogin(true);
        setInitialLoginStage(6);
    };

    const handleChangePassword = () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Change Password Icon', 'User Panel']);
        trackEvent('Rodin - UserPopup - Change Password: Open')
        setShowLogin(true);
        setInitialLoginStage(5);
    };

    const handleChangeUsername = () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Change Username Icon', 'User Panel']);
        trackEvent('Rodin - UserPopup - Change Username: Open')
        setShowLogin(true);
        setInitialLoginStage(4);
    };

    // const handlerToApiDashboard = () => {
    //     // tip({
    //     //     type: 'primary',
    //     //     content: 'Coming soon!',
    //     // });
    //
    //     try {
    //         const url = new URL(window.location.href)
    //         url.pathname = "/api-dashboard"
    //         window.history.pushState(
    //             { page: "api-dashboard" },
    //             "ApiDashboard Page",
    //             url
    //         );
    //     } catch (e) {
    //         Sentry.captureException(e)
    //         console.error(e)
    //     }
    //     setShowApiDashboard(true)
    //     setShowUser(false)
    // }

    const handlerOpenManagement = async () => {
        try {
            const res = await getDashBoardLink()
            if (res?.data?.error) {
                trackEvent('Rodin - UserPopup - Manage Subscription: Failed')
                throw res.data.error
            }
            if (res?.data?.url) {
                trackEvent('Rodin - UserPopup - Manage Subscription: Open')
                const newPage = res.data.url
                const link = document.createElement('a')
                link.target = '_blank'
                link.href = newPage;
                if (document.body) {
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                // window.open(res.data.url, '_blank')
            } else {
                trackEvent('Rodin - UserPopup - Manage Subscription: No Subscribe')
                tip({
                    type: 'error',
                    content: t('TIP_ERR_SUBSCRIBE_SUB_PLAN'),
                });
            }

        } catch (error) {
            trackEvent('Rodin - UserPopup - Manage Subscription: Failed')
            Sentry.captureException(error)
            console.error(error);
        }
    }

    const handlerOpen = (target) => {
        trackEvent('Rodin - UserPopup - Terms: Open')
        setIframe({ type: 'Policy', src: `/${target}.html` })
        _czc.push(['_trackEvent', 'Index', `${target}`, 'Footer Component']);
    }


    return (
        <div className={`user-popup ${className} bg-[var(--topUpBg)] text-[var(--noResultText)] [box-shadow:0_0.25rem_0.375rem_var(--noResultBg)]`} ref={ref}>
            {userInfo && (
                <div className={`user-info bg-[var(--userTitleBg)]`} >
                    <div className="front">
                        <AvatarImage url={userInfo.avatar_url} />
                        <div>
                            <div
                                className={`user-name text-[var(--noResultText)]`}
                            >
                                {userInfo?.username?.length > 11 ? `${userInfo?.username?.slice(0, 11)}...` : userInfo?.username}
                            </div>
                        </div>
                        {userInfo.email
                            && (
                                <div className={`user-email text-[rgb(136,136,136)]`}>
                                    {userInfo.email}
                                </div>
                            )}
                    </div>
                </div>
            )}
            <button className={`hover:bg-[var(--userTitleBg)]`} onClick={handleChangeUsername}>
                <AiFillEdit />
                <span>{t('SETTINGS_USER_INFO_1')}</span>
            </button>
            <button className={`hover:bg-[var(--userTitleBg)]`} onClick={handleChangeAvatar}>
                <AiOutlineUser />
                <span>{t('SETTINGS_USER_INFO_2')}</span>
            </button>
            <button className={`hover:bg-[var(--userTitleBg)]`} onClick={handleChangePassword}>
                <AiOutlineKey />
                <span>{t('SETTINGS_USER_INFO_3')}</span>
            </button>

            {/* <Restricted to="subscription.header.view">
                <button onClick={handlerOpenManagement}>
                    <LuBookmarkPlus />
                    <span>{t('SETTINGS_USER_MANAGE_SUB')}</span>
                </button>
            </Restricted> */}
            <Restricted to="creator.feature">
                <button className={`hover:bg-[var(--userTitleBg)]`} onClick={handlerOpenManagement}>
                    <LuBookmarkPlus />
                    <span>{t('SETTINGS_USER_MANAGE_SUB')}</span>
                </button>
            </Restricted>
            <button className={`hover:bg-[var(--userTitleBg)]`} onClick={handlerOpen.bind(null, 'Terms')}>
                <div className='flex items-center justify-center w-[16px] h-[16px]'>
                    <img className='w-full h-full' src={termsIcon} alt="terms" />
                </div>
                <span>{t('FOOTER_LEGAL_TIPS_2')}</span>
            </button>
            <button className={`hover:bg-[var(--userTitleBg)]`} onClick={handleLogout}>
                <AiOutlineLogout />
                <span>{t('SETTINGS_USER_INFO_4')}</span>
            </button>

        </div>
    );

}))
